/* Game registration and metadata for GameRegistry; exports SpellingBlitz and SpellingBlitzGame, 
wires useSpellingBlitzOrchestrator as the orchestrator */

import { registerGame } from '../../core/GameRegistry';
import { useSpellingBlitzOrchestrator } from './useSpellingBlitzOrchestrator';
import SpellingBlitzSettingsPanel from './SpellingBlitzSettingsPanel';

export { default as SpellingBlitz } from './SpellingBlitz';
export { default as SpellingBlitzGame } from './SpellingBlitzGame';

const SpellingBlitzDefinition = {
  slug: 'spelling-blitz',
  name: 'Spelling Blitz',
  description: 'Choose your game mode',
  path: '/games/spelling-blitz',
  useOrchestrator: useSpellingBlitzOrchestrator,
  GameComponent: () => import('./SpellingBlitz'),
  instructions: 'How to Play:\nUse the honeycomb letters to spell words.\nUsing the center letter is required.\nEach letter can be used as many times as necessary.\nScore points for each valid word found!',
  modes: [
    { key: 'solo',        label: 'Play Solo',        icon: '🎮', callbackProp: 'onPlaySolo' },
    { key: 'multiplayer', label: 'Play With Friends', icon: '👥', callbackProp: 'onPlayWithFriends' },
  ],
  SettingsPanel: SpellingBlitzSettingsPanel,
  features: {
    solo: true,
    multiplayer: true,
    zen: false,
    daily: false,
  },
};

registerGame(SpellingBlitzDefinition);
export default SpellingBlitzDefinition;
